"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PureMyAccount = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _WithAddPaymentDetailsFinalizationHandler = _interopRequireDefault(require("../WithAddPaymentDetailsFinalizationHandler"));
var _MyAccountMenu = _interopRequireDefault(require("../../components/MyAccountMenu"));
var _MyAccountUserInfo = _interopRequireDefault(require("../../components/MyAccountUserInfo"));
var _MyAccountContent = _interopRequireDefault(require("../../components/MyAccountContent"));
var _PlanDetails = _interopRequireDefault(require("../PlanDetails"));
var _PaymentInfo = _interopRequireDefault(require("../PaymentInfo"));
var _UpdateProfile = _interopRequireDefault(require("../UpdateProfile"));
var _Popup = _interopRequireDefault(require("../../components/Popup/Popup"));
var _Login = _interopRequireDefault(require("../../components/LoginPage/Login"));
var _api = require("../../api");
var _Footer = _interopRequireDefault(require("../../components/Footer"));
var _MyAccountError = _interopRequireDefault(require("../../components/MyAccountError/MyAccountError"));
var _deletePaymentDetails = _interopRequireDefault(require("../../api/PaymentDetails/deletePaymentDetails"));
var _auth = _interopRequireDefault(require("../../services/auth"));
var _myaccountSlice = require("../../redux/myaccountSlice");
var _MyAccountStyled = require("./MyAccountStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-unused-state */

const POPUP_TYPE = {
  notCheckedTerms: 'notCheckedTerms',
  complexUpdate: 'complexUpdate',
  termsUpdateRequired: 'termsUpdateRequired',
  consentsUpdateRequired: 'consentsUpdateRequired'
};
class MyAccount extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "handleLogout", () => {
      this.setState({
        isLogged: false
      });
    });
    (0, _defineProperty2.default)(this, "renderMyAccountContent", () => {
      const {
        customCancellationReasons,
        skipAvailableDowngradesStep,
        skipAvailableFreeExtensionStep,
        myaccountState: {
          activeTab
        }
      } = this.props;
      switch (activeTab) {
        case _myaccountSlice.MYACCCOUNT_TABS.planDetails:
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PlanDetails.default, {
            customCancellationReasons: customCancellationReasons,
            skipAvailableDowngradesStep: skipAvailableDowngradesStep,
            skipAvailableFreeExtensionStep: skipAvailableFreeExtensionStep
          });
        case _myaccountSlice.MYACCCOUNT_TABS.paymentInfo:
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentInfo.default, {});
        case _myaccountSlice.MYACCCOUNT_TABS.updateProfile:
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_UpdateProfile.default, {
            handleLogout: this.handleLogout
          });
        default:
          return null;
      }
    });
    this.state = {
      isLogged: false,
      errors: []
    };
  }
  componentDidMount() {
    const {
      userProfile,
      setCurrentUser,
      setConsents,
      setConsentsError,
      initPublisherConfig,
      adyenConfiguration,
      displayGracePeriodError
    } = this.props;
    document.title = 'My Account';
    if (_auth.default.isLogged()) {
      if (userProfile.consents.length === 0) {
        (0, _api.getCustomerConsents)().then(response => {
          if (!response.errors.length) {
            setConsents(response.responseData.consents);
            this.checkTerms();
          } else {
            setConsentsError(response.errors[0]);
          }
        }).catch(() => setConsentsError('Something went wrong..'));
      }
      if (!userProfile.user) {
        (0, _api.getCustomer)().then(response => {
          if (response.errors.length) {
            this.setState({
              errors: response.errors
            });
          } else {
            setCurrentUser(response.responseData);
          }
        });
      }
      if (adyenConfiguration) {
        initPublisherConfig({
          adyenConfiguration
        });
      }
    }
    if (displayGracePeriodError !== null) {
      initPublisherConfig({
        displayGracePeriodError
      });
    }
  }
  componentDidUpdate(prevProps) {
    const {
      userProfile: {
        consents
      },
      userProfile,
      setCurrentUser,
      setConsents,
      setConsentsError
    } = this.props;
    if (prevProps.userProfile.consents !== consents) {
      this.checkTerms();
    }
    if (_auth.default.isLogged()) {
      if (userProfile.consents.length === 0) {
        (0, _api.getCustomerConsents)().then(response => {
          if (!response.errors.length) {
            setConsents(response.responseData.consents);
            this.checkTerms();
          } else {
            setConsentsError(response.errors[0]);
          }
        }).catch(() => setConsentsError('Something went wrong..'));
      }
      if (!userProfile.user) {
        (0, _api.getCustomer)().then(response => {
          if (response.errors.length) {
            this.setState({
              errors: response.errors
            });
          } else {
            setCurrentUser(response.responseData);
          }
        });
      }

      // delete old payment details when paypal payment details were updated successfully
      const paymentDetailsToDelete = new URLSearchParams(window.location.search).get('deletepd');
      if (parseInt(paymentDetailsToDelete, 10)) {
        (0, _deletePaymentDetails.default)(paymentDetailsToDelete);
      }
    }
  }
  checkTerms() {
    const {
      userProfile: {
        consents
      }
    } = this.props;
    if (consents.length !== 0) {
      // Not checked required terms
      const notCheckedTerms = consents.filter(item => item.required && item.state === 'declined' && item.version === item.newestVersion);
      if (notCheckedTerms.length) {
        this.renderPopup(true, POPUP_TYPE.notCheckedTerms, notCheckedTerms);
        return;
      }

      // New version of terms and consents
      const consentsUpdateRequired = consents.filter(item => !item.required && item.needsUpdate === true);
      const termsUpdateRequired = consents.filter(item => item.required && item.version !== item.newestVersion);
      if (termsUpdateRequired.length && consentsUpdateRequired.length) {
        this.renderPopup(true, POPUP_TYPE.complexUpdate, [...termsUpdateRequired, ...consentsUpdateRequired]);
      } else if (termsUpdateRequired.length) {
        this.renderPopup(true, POPUP_TYPE.termsUpdateRequired, termsUpdateRequired);
      } else if (consentsUpdateRequired.length) {
        this.renderPopup(true, POPUP_TYPE.consentsUpdateRequired, consentsUpdateRequired);
      } else {
        // hide popup after submitting
        this.renderPopup(false);
      }
    }
  }
  renderPopup(isOpen) {
    let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    let consents = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    const {
      showPopup,
      hidePopup
    } = this.props;
    if (isOpen) {
      showPopup({
        type,
        consents
      });
    } else hidePopup();
  }
  render() {
    const {
      userProfile: {
        consentsError
      },
      popup: {
        isPopupShown
      },
      myaccountState: {
        activeTab
      }
    } = this.props;
    if (consentsError) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountError.default, {
        generalError: true,
        fullHeight: true
      });
    }
    if (isPopupShown) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Popup.default, {});
    }
    if (_auth.default.isLogged()) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_MyAccountStyled.WrapperStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_MyAccountStyled.HeaderStyled, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountUserInfo.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountMenu.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.default, {
            isCheckout: false,
            isTransparent: true
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountContent.default, {
          children: this.renderMyAccountContent(activeTab)
        })]
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Login.default, {
      isMyAccount: true,
      onSuccess: () => this.setState({
        isLogged: true
      })
    }) // onSuccess required to rerender
    ;
  }
}
exports.PureMyAccount = MyAccount;
MyAccount.propTypes = {
  setCurrentUser: _propTypes.default.func.isRequired,
  setConsents: _propTypes.default.func.isRequired,
  setConsentsError: _propTypes.default.func.isRequired,
  userProfile: _propTypes.default.objectOf(_propTypes.default.any),
  popup: _propTypes.default.objectOf(_propTypes.default.any),
  showPopup: _propTypes.default.func.isRequired,
  hidePopup: _propTypes.default.func.isRequired,
  customCancellationReasons: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string.isRequired,
    value: _propTypes.default.string.isRequired
  })),
  skipAvailableDowngradesStep: _propTypes.default.bool,
  skipAvailableFreeExtensionStep: _propTypes.default.bool,
  initPublisherConfig: _propTypes.default.func.isRequired,
  adyenConfiguration: _propTypes.default.objectOf(_propTypes.default.any),
  displayGracePeriodError: _propTypes.default.bool,
  myaccountState: _propTypes.default.shape({
    activeTab: _propTypes.default.string.isRequired
  }).isRequired
};
MyAccount.defaultProps = {
  userProfile: {
    user: null
  },
  adyenConfiguration: null,
  popup: {
    isPopupShown: false
  },
  customCancellationReasons: null,
  skipAvailableDowngradesStep: false,
  skipAvailableFreeExtensionStep: false,
  displayGracePeriodError: null
};
var _default = exports.default = (0, _reactI18next.withTranslation)()((0, _WithAddPaymentDetailsFinalizationHandler.default)(MyAccount));